import DeleteAccount from './DeleteAccountContainer';

export default DeleteAccount;



// WEBPACK FOOTER //
// ./src/components/pages/User/Profile/components/DeleteAccount/index.js